import { render, staticRenderFns } from "./FurtherMethods.vue?vue&type=template&id=061afac3&scoped=true&"
import script from "./FurtherMethods.vue?vue&type=script&lang=js&"
export * from "./FurtherMethods.vue?vue&type=script&lang=js&"
import style0 from "./FurtherMethods.vue?vue&type=style&index=0&id=061afac3&scoped=true&lang=scss&"
import style1 from "./FurtherMethods.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061afac3",
  null
  
)

export default component.exports